module.exports = __webpack_public_path__ + "img/map.2ffae671.svg";